// extracted by mini-css-extract-plugin
module.exports = {"editWrap":"styles_editWrap__3WapU","editMenu":"styles_editMenu__FWwLR"};